import React from 'react';
import { useTranslation } from 'react-i18next';
import { PiScan } from 'react-icons/pi';
import { motion } from 'framer-motion';

interface FileScannerProps {
  isScanning: boolean;
}

const FileScanner: React.FC<FileScannerProps> = ({ isScanning }) => {
  const { t } = useTranslation();

  return (
    <div className="relative border-2 border-dashed rounded-lg w-full h-[15rem] border-gray-300 bg-gray-50">
      <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
        <motion.div 
          className="bg-blue-600 rounded-full p-4 mb-4 ring-4 ring-blue-200"
          animate={{
            scale: isScanning ? [1, 1.1, 1] : 1
          }}
          transition={{
            duration: 2,
            repeat: isScanning ? Infinity : 0,
            ease: "easeInOut"
          }}
        >
          <PiScan className="h-6 w-6 text-white" />
        </motion.div>

        <motion.p 
          className="text-gray-900 font-medium text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {t('components.dropzone.scanningTitle')}
        </motion.p>

        <motion.p 
          className="text-gray-500 text-sm text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {t('components.dropzone.scanning')}
        </motion.p>
        
        <motion.div 
          className="w-48 mt-4"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
        >
          <div className="h-1 w-full bg-gray-200 rounded-full overflow-hidden">
            <motion.div 
              className="h-full bg-blue-600 rounded-full"
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{ 
                duration: 15,
                ease: "linear",
                repeat: 0
              }}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FileScanner;